var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApiCalls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-api-calls_svg__clip0_2116_7156)",
    stroke: "#586069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 14.502a1 1 0 01-1 1H2a1 1 0 01-1-1v-13a1 1 0 011-1h10.03a1 1 0 01.699.285l1.97 1.921a1.001 1.001 0 01.301.716v11.078z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5.502h-.5a.94.94 0 00-1 .863v.831a.837.837 0 01-.445.717L4 8.52l1.055.606a.839.839 0 01.445.717v.832a.939.939 0 001 .862H7M9 5.502h.5a.939.939 0 011 .863v.831a.838.838 0 00.445.717L12 8.52l-1.055.606a.839.839 0 00-.445.717v.832a.939.939 0 01-1 .862H9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-api-calls_svg__clip0_2116_7156"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgIconApiCalls;